
import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle,
} from '@/components/ui/dialog';
import { Command, CommandList } from '@/components/ui/command';
import { type Contact } from './contacts/types';
import { useContacts } from './contacts/useContacts';
import ContactsSearchHeader from './contacts/ContactsSearchHeader';
import ContactsList from './contacts/ContactsList';
import ManualEntryForm from './contacts/ManualEntryForm';

interface ContactsSelectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectContact: (contact: Contact) => void;
}

const ContactsSelectionDialog: React.FC<ContactsSelectionDialogProps> = ({
  open,
  onOpenChange,
  onSelectContact
}) => {
  const {
    searchTerm,
    setSearchTerm,
    manualEmail,
    setManualEmail,
    showManualEntry,
    setShowManualEntry,
    filteredContacts,
    handleSelectContact,
    handleManualEntry,
    handleDownloadContacts,
  } = useContacts((contact) => {
    onSelectContact(contact);
    onOpenChange(false);
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Select Contact to Re-Gift</DialogTitle>
        </DialogHeader>
        
        {!showManualEntry ? (
          <Command className="rounded-lg border shadow-md">
            <ContactsSearchHeader 
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onDownload={handleDownloadContacts}
            />
            <CommandList>
              <ContactsList 
                contacts={filteredContacts}
                onSelectContact={handleSelectContact}
                onShowManualEntry={() => setShowManualEntry(true)}
              />
            </CommandList>
          </Command>
        ) : (
          <ManualEntryForm 
            manualEmail={manualEmail}
            onEmailChange={setManualEmail}
            onCancel={() => setShowManualEntry(false)}
            onSubmit={handleManualEntry}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ContactsSelectionDialog;
